// tslint:disable:max-line-length

import React from 'react';

export const OperatorIsNotFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M14,14H2V2h12V14z M4,12h8V4H4V12z" />
    </svg>
  );
};
